
import { Component, OnInit,Output,EventEmitter,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PowerUserRoleFormData, PowerUserRoles,PowerUserRoleStatusFormData } from '../../../Models/user-profiles.model';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { SubjectList } from '../../../Models/user-profiles.model';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SubjectResourceAssign } from 'src/app/Models/subject-resource-assignment';
import {SessionService} from '../../../Services/session.service';
import { IGetCodes } from 'src/app/interfaces/codes';
@Component({
  selector: 'app-change-power-user-role-status',
  templateUrl: './change-power-user-role-status.component.html',
  styleUrls: ['./change-power-user-role-status.component.scss']
})
export class ChangePowerUserRoleStatusComponent implements OnInit {
  @Output() Closepopup: EventEmitter<any> = new EventEmitter<any>();
  closemodalpopup:any;
  selectedRole: any;
  selectedPowerUserRole: any;
  currentRole: string;
  subjectType: IGetCodes[];
  Statusdetails:any;
  DisableEnddate:boolean=false;
  DisableStartdate:boolean=true;
  ToStatus:string;
  todayDate:Date = new Date();
  modifyUserRoleStatus: PowerUserRoleStatusFormData;
  roles: any[];
  constructor(
    public session:SessionService,
    public toastr: ToastrService,
    private router: Router,
    public userService: UserManagementService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
  ) {
    this.todayDate = new Date(this.todayDate.setDate(this.todayDate.getDate()));
   }
  PowerUserRoleStatusForm = new FormGroup({
    powerUserId: new FormControl('',Validators.required),
    status: new FormControl(''),
    selectRole: new FormControl('', Validators.required),
    startDate: new FormControl('', Validators.required),
    powerUser: new FormControl(''),
    name: new FormControl(''),
    endDate: new FormControl(''),
    roleStatus: new FormControl('',),
    comments: new FormControl('')
  })
  ngOnInit(): void {
    //this.getSubjectType();
    // this.getStatusType();
    this.route.params.subscribe((e)=>{
      
      const payload={
        "PowerUserRoleID": null,
        "SubjectID": null,
        "PowerUserID": e.id,
        "ScreenName": null,
      }
      this.getExperienceType();
    this.userService.getPowerUserRoleById(payload).subscribe(
      (res:any) => {

        this.getPoweruserRoleByIdResponse(res.PowerUserRole) },
      error => { console.log(error) }
    )
  })

    
  }

  getPoweruserRoleStatus(data:any){
     this.Statusdetails=data
  }

  getPoweruserRoleByIdResponse(data: any) {    
    this.selectedPowerUserRole = data[0]; 
    this.PowerUserRoleStatusForm.controls['powerUserId'].setValue(this.selectedPowerUserRole.Power_User_ID);
    this.PowerUserRoleStatusForm.controls['status'].setValue(this.selectedPowerUserRole.Power_User_Role_Status_Type_Code);

    if(this.selectedPowerUserRole.Power_User_Role_Status_Type_Code!='Approved'){
      this.DisableEnddate=true;
    }
    this.PowerUserRoleStatusForm.controls['name'].setValue(this.selectedPowerUserRole.Power_User_Name);
    this.PowerUserRoleStatusForm.controls['selectRole'].setValue(this.selectedPowerUserRole.Power_User_Role_Type_Code);
    this.currentRole = this.selectedPowerUserRole.Power_User_Role_Type_Code;
    this.PowerUserRoleStatusForm.controls['startDate'].setValue(new Date(this.todayDate.setDate(this.todayDate.getDate())));
    this.PowerUserRoleStatusForm.controls['endDate'].setValue(this.selectedPowerUserRole.End_Date);
    this.PowerUserRoleStatusForm.controls['comments'].setValue(this.selectedPowerUserRole.Comment_Text);
 
    this.userService.PowerUserRoleStatusPermission({'PowerUserRoleType':this.selectedPowerUserRole.Power_User_Role_Type_Code,'StatusType':this.selectedPowerUserRole.Power_User_Role_Status_Type_Code}).subscribe(
      res => { this.getPoweruserRoleStatus(res) },
      error => { console.log(error) }
    )
  }

  getExperienceType() {
    this.userService.getCodes('POWER_USER_ROLE_TYPE').subscribe(
      res => {
        this.getRoleTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }
  error:any={isError:false,errorMessage:''};
  compareEndDates(){
    //this.Editformvalidation();
    if(new Date(this.PowerUserRoleStatusForm.controls['endDate'].value)<new Date(this.PowerUserRoleStatusForm.controls['startDate'].value)){
       this.error={isError:true,errorMessage:'End Date cant less than start date'};
    }
    else{
      this.error={isError:false,errorMessage:''};
    }
    if(this.PowerUserRoleStatusForm.controls['endDate'].value==null){
      this.error={isError:false,errorMessage:''};
     }

     if(this.PowerUserRoleStatusForm.controls['endDate'].value==this.datepipe.transform(this.selectedPowerUserRole.EndDate, 'dd/MM/yyyy')){
 
      this.error={isError:false,errorMessage:''};
    }
   }

   error1:any={isError:false,errorMessage:''};
   compareStartDates(){

    if(new Date(this.PowerUserRoleStatusForm.controls['startDate'].value)<new Date(this.todayDate.setDate(this.todayDate.getDate()))){
       this.error1={isError:true,errorMessage:'Start Date cant before current date'};
    }
    else{
      this.error1={isError:false,errorMessage:''};
    }
    this.compareEndDates();

   }
  getRoleTypeResponse(data: any) {
    var tempRoleType: any[] = []
    data.forEach((element: { Code: any; Name: any; }) => {
      tempRoleType.push({
        Code: element.Code,
        Name: element.Name
      })

    });
    this.roles =[...tempRoleType]
  }


  getSubjectType() {
    this.userService.getSubject('SUBJECT').subscribe(
      res => {
        this.getSubjectTypeResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  getSubjectTypeResponse(data: any) {


    this.subjectType = data;
  }



  onSelectRole(event: any) {
    this.selectedRole = event.target.value;
  }

  UpdateStatus(event: any){
    this.ToStatus = event.target.value;
  }
  OnClickCancelButton(){
    this.Closepopup.emit(this.closemodalpopup);
  }

  ChangePowerUserRoleStatus(data: any) {    
    let tempUserRoleStatus:PowerUserRoleStatusFormData;
    tempUserRoleStatus = {} as PowerUserRoleStatusFormData;

    //this code can be cleaned up using the same variable selectedUserRole used before
    tempUserRoleStatus = {
      PowerUserRoleStatusID:this.selectedPowerUserRole.Power_User_Role_Status_ID,
      PowerUserRoleID: this.userService.powerUserRoleID,
      CommentText: data.comments,
      EndDate: this.datepipe.transform(data.endDate,'MM/dd/yyyy'),
      PowerUserRoleStatusTypeCode:this.ToStatus,
      NewPowerUserRoleStatusID:null,
      LoggedInUser: this.session.getUser()
     
    }

    this.modifyUserRoleStatus = tempUserRoleStatus;   
    this.userService.UpdatePowerUserStatus(this.modifyUserRoleStatus).subscribe(
     
      res => {
        this.toastr.success('Success!', 'Status Is Updated!');
        this.router.navigate(['User/Poweruserlist']);
        this.Closepopup.emit(this.closemodalpopup);
      },
      error => {
       this.toastr.error('ERROR!', 'Uniquekey constraint');
      }
    )
  }

  OnClickSaveButton() {
    this.ChangePowerUserRoleStatus(this.PowerUserRoleStatusForm.value)
  }

 


}
